<template>
  <div class="myInfoPage">
    <div
      :style="{
        display: infoObj.phone && infoObj.stuTeacher !== '' ? 'block' : 'none',
      }"
      class="server-info"
    >
      <div class="box-border baseInfo">
        <p class="title">
          <img src="../../assets/images/students@3x.png" alt="title1" />
          <span>学员基本信息</span>
        </p>
        <div class="content loss-content">
          <dl>
            <dt>姓名：</dt>
            <dd>{{ infoObj.name || "无" }}</dd>
          </dl>
          <dl>
            <dt>手机号：</dt>
            <dd>{{ infoObj.phone || "无" }}</dd>
          </dl>
          <dl>
            <dt>意向学科：</dt>
            <dd>{{ infoObj.stuName || "无" }}</dd>
          </dl>
          <dl>
            <dt>添加好友时间：</dt>
            <dd>{{ infoObj.firstAddTime || "无" }}</dd>
          </dl>
          <dl>
            <dt>流失好友时间：</dt>
            <dd>{{ infoObj.lostTime || "无" }}</dd>
          </dl>
        </div>
      </div>
      <!-- 添加老师 -->
      <div
        class="box-border baseInfo teacherGroup"
        v-if="infoObj.userList.length > 0"
      >
        <p class="title">
          <img src="../../assets/images/students@3x.png" alt="title1" />
          <span>已加企微老师</span>
        </p>
        <div class="content">
          <div class="addTeacGrou">
            <span
              v-for="item in infoObj.userList"
              :key="item.id"
              :class="
                item.trackState === 5 || item.lostTime ? '' : 'activeWork'
              "
            >
              {{ item.firstUserName }}
            </span>
          </div>
          <p class="show" @click="expandClick">
            {{ "展开更多(" + infoObj.userList.length + ")" }}
            <van-icon name="play" />
          </p>
        </div>
      </div>
      <!--添加群组-->
      <div
        class="box-border baseInfo teacherGroup"
        v-if="infoObj.groupList.length > 0"
      >
        <p class="title">
          <img src="../../assets/images/students@3x.png" alt="title1" />
          <span>已加企微群组</span>
        </p>
        <div class="content">
          <div class="addTeacGrou">
            <span
              v-for="item in infoObj.groupList"
              :key="item.id"
              :class="item.delFlag == 1 ? '' : 'activeWork'"
            >
              {{ item.groupName || "默认群组" }}
            </span>
          </div>
          <p class="show" @click="expandClick">
            {{ "展开更多(" + infoObj.groupList.length + ")" }}
            <van-icon name="play" />
          </p>
        </div>
      </div>
      <!-- 这 -->
      <div class="box-border studentStatus">
        <p class="title">
          <img src="../../assets/images/status@3x.png" alt="title2" />
          <span>学员状态信息</span>
        </p>
        <div class="content status-c">
          <dl>
            <dt>类型：</dt>
            <dd>{{ infoObj.stuType || "无" }}</dd>
          </dl>
          <dl>
            <dt>来源渠道：</dt>
            <dd>{{ infoObj.stuFrom || "无" }}</dd>
          </dl>
          <dl>
            <dt>咨询师：</dt>
            <dd>{{ infoObj.stuTeacher || "无" }}</dd>
          </dl>
          <dl>
            <dt>咨询师所在部门：</dt>
            <dd>{{ infoObj.stuTeacherDept || "无" }}</dd>
          </dl>
          <dl>
            <dt>分配时间：</dt>
            <dd>{{ formattime(infoObj.stuFpTime) || "无" }}</dd>
          </dl>
          <dl>
            <dt>跟单时间：</dt>
            <dd>{{ formattime(infoObj.stuGdTime) || "无" }}</dd>
          </dl>
          <dl>
            <dt>状态：</dt>
            <dd>
              <span>
                {{
                  infoObj.status === "1"
                    ? "已报名"
                    : infoObj.status === "2"
                    ? "未报名"
                    : ""
                }}
              </span>
            </dd>
          </dl>
          <dl>
            <dt>学员质量：</dt>
            <dd class="flex-center">
              <span>{{ zhiliangShow(columns, infoObj) || "无" }}</span>
              <!--  -->
            </dd>
          </dl>
        </div>
      </div>

      <div class="record box-border">
        <div class="title flex-between">
          <div class="flex-center">
            <img src="../../assets/images/follower.png" alt="title3" />
            <span>跟单记录</span>
          </div>
        </div>
        <vants-table
          :showoperate="true"
          :option="option"
          @father="childDialog"
          tablestyle="tablestyle"
          :tableData="tableData"
        />
      </div>
    </div>

    <!-- 跟单详情 -->
    <van-dialog
      v-model="showDetail"
      title="跟单详情"
      width="80%"
      class="detail-dialog"
    >
      <div>
        <span>跟单人：</span>
        <span>{{ infoObj.realName }}</span>
      </div>
      <div>
        <span>学员类型：</span>
        <span>{{ traceShow(tracelist, infoObj) }}</span>
      </div>
      <div>
        <span>一级分类：</span>
        <span>{{ detailObj.stairName || "无" }}</span>
      </div>
      <div>
        <span>二级分类：</span>
        <span>{{ detailObj.foxbaseName || "无" }}</span>
      </div>
      <div>
        <span>三级分类：</span>
        <span>{{ detailObj.threeLevelName || "无" }}</span>
      </div>
      <div>
        <span>本次跟单时间：</span>
        <span>{{ handleTime(detailObj.createtime) || "无" }}</span>
      </div>
      <div>
        <span>下次跟单时间：</span>
        <span>{{ handleTime(detailObj.nexttracetime) || "无" }}</span>
      </div>
      <div>
        <span>预计学习时间：</span>
        <span>{{ handleTime(detailObj.planstudytime) || "无" }}</span>
      </div>
      <div>
        <span>本次跟单内容：</span>
        <span>{{ detailObj.remark || "无" }}</span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import vantsTable from "@/components/table.vue";
import { Toast } from "vant";
import moment from "moment";
import { wxConfig } from "../fastReply/js/config";
import { addressBar, wefunstatistics, getUrlParam } from "@/utils/public";
import {
  zhilianglist,
  getLossUserInfo,
  documentaryRecord,
  updateZhiLiang,
  tracelist,
} from "@/server/api.js";
export default {
  components: { vantsTable },
  data() {
    return {
      infoObj: {
        groupList: [],
        userList: [],
      },
      showPicker: "",
      columns: [],
      showDetail: false,
      showUpdate: false,
      tracelist: [],
      option: {
        column: [
          {
            label: "跟单人",
            tableDataprop: "realName",
          },
          {
            label: "跟单时间",
            tableDataprop: "createtime",
          },
          {
            label: "跟单内容",
            tableDataprop: "remark",
          },
        ],
      },
      tableData: [],
      detailObj: {},
      value: "",
      flag: false,
      loginingStatus: false,
      userId: "",
      tenId: "",
      zxuserId: "",
      wechatUserId: "",
      userIdsarr: [],
      windowurl:
        window.location.href.split("?")[0] || "http://tm-qw.1000phone.net/info",
      jsList: [
        "getCurExternalContact",
        "showOptionMenu",
        "showMenuItems",
        "onMenuShareTimeline",
        "openEnterpriseChat",
        "selectExternalContact",
      ],
      // wechatUserId: "wm6lPiDAAA5vmb08owQQ4DJcvUVdd3xA",
    };
  },
  watch: {
    // "$store.state.tokenFlag": function (newval) {
    //   if (newval) {
    //     // alert(document.domain + "|domains");
    //     wxConfig(this.windowurl, this.jsList).then((res) => {
    //       this.userId = localStorage.getItem("userid");
    //       wefunstatistics("2", window.location.href.split("#")[0]);
    //       this.hasuserid();
    //     });
    //   }
    // },
  },
  async mounted() {
    document.title = "芯源助手";
    if (localStorage.getItem("token")) {
      await this.getZhilianglist();
      wxConfig(this.windowurl, this.jsList).then(() => {
        this.userId = localStorage.getItem("userid");
        this.hasuserid();
      });
    } else {
      addressBar("token", this.windowurl);
    }
  },
  methods: {
    hasuserid() {
      let that = this;
      that.getUserInfos();
      that.gettracelist();
    },

    // 用户详情
    getUserInfos() {
      // let url = window.location.href.split("/");
      // let params = {
      //   userId: url[url.length - 2],
      //   tenId: url[url.length - 1],
      // };
      let params = {
        userId: this.$route.params.userId,
        tenId: this.$route.params.tenId,
      };
      getLossUserInfo(params).then((res) => {
        if (res.code !== "200") return Toast.fail(res.msg);
        this.infoObj = res.data;
        this.$nextTick(() => {
          let customerList = document.querySelectorAll(".addTeacGrou");
          for (let x of customerList) {
            if (x.offsetHeight > 100) {
              x.classList.add("overFlow");
              x.nextElementSibling.style.display = "block";
            }
          }
        });
      });
    },
    // 质量列表
    getZhilianglist() {
      zhilianglist().then((res) => {
        this.columns = res.data;
      });
    },
    recordLog() {
      documentaryRecord({ askId: this.infoObj.askId }).then((res) => {
        // console.log(res.data);
        this.tableData = res.data;
      });
    },

    childDialog(obj) {
      this.showDetail = true;
      // console.log(obj);
      this.detailObj = obj;
    },

    zhiliangShow(zhilianglist, infoObj) {
      if (zhilianglist && zhilianglist.length > 0) {
        let item = zhilianglist.find(
          (item) => item.did === Number(infoObj.zhiliang)
        );
        return item && item.dname;
      }
    },
    traceShow(tracelist, infoObj) {
      if (tracelist && tracelist.length > 0) {
        let item = tracelist.find(
          (item) => item.did === Number(infoObj.zstype)
        );
        return item && item.dname;
      }
    },
    expandClick() {},

    gettracelist() {
      tracelist().then((res) => {
        this.tracelist = res.data;
      });
    },
    handleTime(time) {
      if (!time) return false;
      return time.slice(0, 10);
    },
    formattime(time) {
      if (time) {
        return moment(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      }
      return "";
    },
  },
};
</script>
<style scoped lang="less">
@import "./css/index.less";
.loss-content dt {
  width: 200px !important;
  flex-shrink: 0;
}
</style>
